import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
import { jsxs, jsx } from 'react/jsx-runtime';
import { Column, Grid, Text, Row } from '@dls/web';
import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { isAMUser } from '../../../../../../authentication/helpers/utils.js';
import { getTheme } from '../../../../helpers/styles.js';
import '@geit/ui-components';
import theme from '../../../../theme/index.js';
import AccountSettings from './AccountSettings/index.js';
import DesktopMenu from './DesktopMenu/index.js';
import List from './List.js';
import ListItem from './ListItem.js';
import Logo from './Logo.js';
import Logout from './Logout.js';
import Notification from './Notification.js';
import Profile from './Profile.js';
import Support from './Support.js';
import UserEntity from './UserEntity.js';
import { RHSControlListItem, SCHeaderDesktop } from './styles.js';
const SCFlexColumnAuto = styled(Column)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  padding: 0;\n"])));
const SCFlexColumnAutoEnd = styled(Column)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n"])));
const SCPaddingColumn = styled(SCFlexColumnAutoEnd)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-top: 3px;\n  padding-bottom: 6px;\n"])));
const RHSCInfoListItem = styled(RHSControlListItem)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-left: 16px;\n  margin-right: 16px;\n"])));
const RHSCInfoListItemMs = styled(RHSCInfoListItem)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-left: 0.5rem;\n"])));
const RHSCTextItem = styled(RHSControlListItem)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-right: 3rem;\n"])));
const LogoListItem = styled(ListItem)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"])));
const SCDivW100 = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const HeaderTopGrid = styled(Grid)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 2px;\n"])));
const HeaderGrid = styled(Grid)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: 6px;\n"])));
const SCAccountSettings = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
const DesktopRHSControls = _ref => {
  let {
    theme,
    onClickLogout
  } = _ref;
  return /* @__PURE__ */jsxs(List, {
    isInline: true,
    children: [/* @__PURE__ */jsx(RHSCInfoListItem, {
      children: /* @__PURE__ */jsx(Support, {
        theme
      })
    }), /* @__PURE__ */jsx(RHSCInfoListItemMs, {
      children: /* @__PURE__ */jsx(Logout, {
        theme,
        onClick: onClickLogout
      })
    })]
  });
};
const DesktopControls = _ref2 => {
  let {
    theme,
    additionalControl
  } = _ref2;
  const [openAccountSettings, setOpenAccountSettings] = useState(false);
  const onClose = useCallback(() => {
    setOpenAccountSettings(false);
  }, []);
  return /* @__PURE__ */jsxs(List, {
    isInline: true,
    children: [!isAMUser() && /* @__PURE__ */jsx(RHSControlListItem, {
      children: /* @__PURE__ */jsxs(SCAccountSettings, {
        children: [/* @__PURE__ */jsx(Profile, {
          theme,
          onClick: () => setOpenAccountSettings(true)
        }), /* @__PURE__ */jsx(AccountSettings, {
          open: openAccountSettings,
          onClose
        })]
      })
    }), /* @__PURE__ */jsx(Notification, {
      theme
    }), additionalControl && /* @__PURE__ */jsx(RHSControlListItem, {
      children: additionalControl
    })]
  });
};
const DesktopHeader = _ref3 => {
  let {
    baseUrl,
    logoLink,
    logoAlt,
    logoSrc,
    menuHoverKey,
    onMenuMouseEnter,
    onMenuMouseLeave,
    theme: theme$1,
    menuItems = [],
    isAnonymous,
    additionalControl,
    onApplySegment,
    onClickLogo,
    onClickLogout,
    onClickMenu
  } = _ref3;
  return /* @__PURE__ */jsxs(SCDivW100, {
    children: [!isAnonymous && /* @__PURE__ */jsx(SCHeaderDesktop, {
      theme: getTheme(isAMUser()),
      id: "deskMenuTop",
      children: /* @__PURE__ */jsx(HeaderTopGrid, {
        children: /* @__PURE__ */jsxs(Row, {
          middle: "sm",
          children: [/* @__PURE__ */jsx(SCFlexColumnAuto, {}), isAMUser() && /* @__PURE__ */jsx(SCPaddingColumn, {
            children: /* @__PURE__ */jsx(RHSCTextItem, {
              children: /* @__PURE__ */jsx(ItalicText, {
                color: theme.colours.yellow_l6,
                children: "You are currently viewing customer\u2019s account (VIEW ONLY)"
              })
            })
          }), /* @__PURE__ */jsx(SCFlexColumnAutoEnd, {
            children: /* @__PURE__ */jsx(UserEntity, {
              isAMUser: isAMUser(),
              onApplyChange: onApplySegment
            })
          }), /* @__PURE__ */jsx(SCFlexColumnAutoEnd, {
            children: /* @__PURE__ */jsx(DesktopRHSControls, {
              theme: getTheme(isAMUser()),
              onClickLogout
            })
          })]
        })
      })
    }), /* @__PURE__ */jsx(SCHeaderDesktop, {
      theme: theme$1,
      id: "deskMenuBottom",
      children: /* @__PURE__ */jsx(HeaderGrid, {
        children: /* @__PURE__ */jsxs(Row, {
          middle: "sm",
          children: [/* @__PURE__ */jsx(SCFlexColumnAuto, {
            children: /* @__PURE__ */jsxs(List, {
              isInline: true,
              children: [/* @__PURE__ */jsx(LogoListItem, {
                children: /* @__PURE__ */jsx(Logo, {
                  baseUrl,
                  link: logoLink,
                  alt: logoAlt,
                  src: logoSrc,
                  onClick: onClickLogo
                })
              }), !isAnonymous && /* @__PURE__ */jsx(DesktopMenu, {
                baseUrl,
                menuItems,
                menuHoverKey,
                onMenuMouseEnter,
                onMenuMouseLeave,
                theme: theme$1,
                onClickMenu
              })]
            })
          }), !isAnonymous && /* @__PURE__ */jsx(SCFlexColumnAutoEnd, {
            children: /* @__PURE__ */jsx(DesktopControls, {
              theme: theme$1,
              additionalControl
            })
          })]
        })
      })
    })]
  });
};
const ItalicText = styled(Text)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-style: italic;\n"])));
export { DesktopHeader as default };